<template>
    <v-card color="" elevation="0" class="px-4">
        <v-divider></v-divider>
        <div class="d-flex align-strech pt-3 pb-7 mt-2">
            <v-text-field style="flex: 0 1 300px" v-model="search" append-icon="mdi-magnify" outlined
                :label="this.$t('sales.clientsList.search')" single-line dense hide-details></v-text-field>
            <v-spacer></v-spacer>
            <v-btn color="success" height="40" elevation="0" class="ml-2" @click="addNew()">{{
                $t('common.add')
                }}</v-btn>
        </div>
        <v-card outlined>
            <v-data-table :sort-by="['log']" :sort-desc="[false]" :headers="headers" :items="documents" :footer-props="{
                showFirstLastPage: true,
                'items-per-page-options': [10, 25, 50]
            }" :items-per-page="25" :search="search">
                <template v-slot:[`item.createdOn`]="{ item }">
                    <span class="hide-text">{{ item.createdOn }}</span>{{ item.createdOn | dateTime }}
                </template>

                <template v-slot:[`item.code`]="{ item }">
                    <v-chip v-if="item.code">{{ item.code }}</v-chip>
                    <template v-else>-</template>
                </template>


                <template v-slot:[`item.from`]="{ item }">
                    <span class="hide-text">{{ item.from }}</span>{{ item.from | date }} <span
                        v-if="item.dueDate && item.from">{{ $t('common.to') }}</span> {{ item.dueDate | date }}
                </template>
                <template v-slot:[`item.discountValue`]="{ item }">
                    <template v-if="item.discountType == 'percent'">
                        {{ item.discountValue }}%
                    </template>
                    <template v-if="item.discountType == 'fixed'">
                        {{ $n(item.discountValue, 'currency') }}
                    </template>
                    <!-- <v-chip v-else label color="error lighten-2 " small>{{ $t('sales.clientsList.confirmed') }}</v-chip> -->
                </template>
                <template v-slot:[`item.log`]="{ item }">
                    <span v-html="lastLog(item)"></span><v-btn class="ml-2" icon small v-if="item.log.length"
                        @click="openHistory(item)"><v-icon>mdi-history</v-icon></v-btn>
                </template>
                <template v-slot:[`item.status`]="{ item }">



                    <template v-if="item.status">
                        <v-chip class="ml-1" v-if="checkValid(item) == 1" label color="info" small>Aguardando
                            início</v-chip>
                        <v-chip class="ml-1" v-if="checkValid(item) == 2" label color="success " small>Ativo</v-chip>
                        <v-chip class="ml-1" v-if="checkValid(item) == 3" label color="error lighten-2 "
                            small>Expirado</v-chip>
                    </template>
                    <v-chip label small dark color="red lighten-2" v-else>{{
                        $t(`common.inactive`) }}</v-chip>


                </template>
                <template v-slot:[`item.id`]="{ item }">
                    <v-btn icon small @click="edit(item)" class="mr-1"><v-icon>mdi-pencil-outline</v-icon></v-btn>

                    <v-btn icon small color="red" @click="remove(item)"><v-icon>mdi-trash-can-outline</v-icon></v-btn>
                </template>
            </v-data-table>
        </v-card>
        <v-dialog v-model="show" width="900">
            <v-card class="mx-auto">
                <v-card-title>{{ $t('marketing.promotions.form.title') }}</v-card-title>
                <v-card-text>
                    <v-text-field v-model="form.name" :label="$t('marketing.promotions.form.name')"></v-text-field>
                    <v-select :label="$t('marketing.promotions.form.role')" v-model="form.role"
                        :items="$t('marketing.promotions.types')" item-value="code" item-text="label"></v-select>
                    <v-text-field v-if="form.role == 'Cupom de desconto'" :disabled="form.id && form.id" v-model="form.code" :label="$t('marketing.promotions.form.code')"  :rules="form.id ? [] :[
                      
                        fieldRules.minLength(form.code, 3), 
                        fieldRules.maxLength(form.code, 10),
                        fieldRules.noRepeat(form.code, allCodes)
            
          ]"></v-text-field>

                    <v-select :label="$t('marketing.promotions.form.discountType')" v-model="form.discountType"
                        :items="$t('marketing.promotions.discountTypes')" item-value="value"
                        item-text="label"></v-select>
                    <v-text-field v-if="form.discountType == 'percent'" min="0"
                        :max="form.discountType == 'percent' ? 99.99 : ''" suffix="%" type="number"
                        v-model="form.discountValue"
                        :label="$t('marketing.promotions.form.discountValue')"></v-text-field>

                    <VuetifyMoney v-else :label="$t('marketing.promotions.form.discountValue')"
                        v-model="form.discountValue" v-bind:options="options5" />
                    <VuetifyMoney :label="$t('marketing.promotions.form.minValue')" v-model="form.minValue"
                        v-bind:options="options5" />

                    <VuetifyMoney :label="$t('marketing.promotions.form.maxValue')" v-model="form.maxValue"
                        v-bind:options="options5" />

                                        <v-text-field v-model="form.limit" :label="$t('marketing.promotions.form.limit')"></v-text-field>

                    <v-menu>
                        <template v-slot:activator="{ on, attrs }">

                            <v-text-field :label="$t('marketing.promotions.form.from')" readonly v-model="formatedFrom"
                                v-bind="attrs" v-on="on" append-icon="mdi-calendar"></v-text-field>

                        </template>
                        <v-date-picker v-model="form.from"></v-date-picker>
                    </v-menu>

                    <v-menu>
                        <template v-slot:activator="{ on, attrs }">

                            <v-text-field :label="$t('marketing.promotions.form.dueDate')" :rules="[fieldRules.isBefore(form.dueDate, form.from)]" readonly
                                v-model="formatedDueDate" v-bind="attrs" v-on="on"
                                append-icon="mdi-calendar"></v-text-field>

                        </template>
                        <v-date-picker :allowed-dates="allowDates" v-model="form.dueDate"></v-date-picker>
                    </v-menu>
                    <v-switch v-model="form.accumulative"
                        :label="form.accumulative ? 'Desconto acumulativo' : 'Desconto não acumulativo'"></v-switch>
                    <v-switch v-model="form.status"
                        :label="form.status == 1 ? $t('common.active') : $t('common.inactive')"></v-switch>
                    <div class="d-flex pt-3">
                        <v-spacer></v-spacer>
                        <v-btn class="mr-1" text @click="show = false">{{ $t('common.cancel') }}</v-btn>
                        <v-btn elevation="0" color="success" @click="submit()">{{ $t('common.save') }}</v-btn>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog v-model="toDelete" width="480">
            <v-card class="mx-auto">
                <v-card-title>
                    <div class="d-flex justify-space-between">
                        <span>{{ $t('marketing.deleteTitle') }}</span>
                        <v-btn icon color="grey" @click="toDelete = false"><v-icon>mdi-close</v-icon></v-btn>
                    </div>
                </v-card-title>
                <v-card-subtitle>{{ $t('marketing.deleteSubTitle') }}
                </v-card-subtitle>
                <v-card-actions class="d-flex justify-end pa-4">
                    <v-btn text @click="toDelete = false">{{ $t('common.cancel') }}</v-btn>
                    <v-btn @click="removeReserved()" color="error" elevation="0">{{ $t('common.remove') }}</v-btn>
                </v-card-actions>
            </v-card>

        </v-dialog>
        <v-dialog v-model="historic.show" width="540">
      <v-card class="mx-auto" v-if="historic.show && historic.item">
        <v-card-title>Histórico de utilização</v-card-title>
        <v-card-text>
          <div v-for="(item, i) in historic.item.log" :key="i">
            <v-card outlined class="pa-2 mb-2">
              <div class="d-flex align-center">
                <div class="mb-2 mr-4">
                  <label>Data</label>
                  <div class="text-p font-weight-bold">
                    {{ item.date | dateTime }}
                  </div>
                </div>
                <div class="mb-2">
                  <label>Pedido</label>
                  <div class="text-p font-weight-bold">
                    {{ item.order }}
                  </div>
                </div>
                <div class="mb-2" style="flex: 1 1 10%">
                  <label>&nbsp;</label>
                  <div class="text-p font-weight-bold text-end text-right d-flex justify-end">
                    <v-btn color="primary" :to="`/sales/orders/${item.order}`" text target="_blank">Ver pedido <v-icon class="ml-2">mdi-open-in-new</v-icon></v-btn>
                  </div>
                </div>
              </div>
              

            </v-card>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    </v-card>
</template>
<script>
import VuetifyMoney from "@/components/VuetifyMoney";
import moment from 'moment'
import config from '@/store/config'
import { mapActions } from "vuex";
// import useVuelidate from "@vuelidate/core";
// import { required, numeric, minLength, maxLength } from "@vuelidate/validators";
// import validations from "@/plugins/validations";
// import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";
import { initializeApp } from "firebase/app";

import { getFirestore, collection, query, deleteDoc, setDoc, doc, getDocs, writeBatch } from "firebase/firestore";
export default {
    name: 'PromotionsList',
    components: {
        VuetifyMoney,
    },

    // setup() {
    //     return { v$: useVuelidate() };
    // },


    data() {
        return {
            historic: {
                show: false,
                item: []
            },
            options5: {
                locale: this.$t('sales.commercialPolicies.add.form.optionsCurrency.locale'),
                prefix: this.$t('sales.commercialPolicies.add.form.optionsCurrency.prefix'),
                suffix: "",
                length: 9,
                precision: 2,
            },
            fieldRules: {
                // required(value, name){
                //     return !value || value.length == 0 ? `O campo ${name} é obrigatório` : true
                // },
                minLength(value, ref){
                    return value && value.length < ref ? `Utilize ao menos ${ref} caracteres` : true
                },
                maxLength(value, ref){
                    return value &&  value.length > ref ? `Utilize até ${ref} caracteres` : true
                },
                noRepeat(value, ref){
                    return value && ref.length && ref.includes(value) ? `${value} já está em uso` : true
                },
                isBefore(value, ref) {
                    return ref && value && moment(value,'YYYY-MM-DD').isBefore(moment(ref,'YYYY-MM-DD')) ? 'A data de vencimento deve ser posterior a data de início' : true
                }
            },
            show: false,
            removeSnap: null,
            toDelete: false,
            removed: false,
            calendarPicker: false,
            processing: false,

            form: {
                accumulative: false,
                name: "",
                role: "",
                code: "",
                discountType: "",
                discountValue: 0,
                minValue: 0,
                maxValue: 0,
                limit: null,
                fromDate: null,
                toDate: null,
                log: []

            },
            model: {
                accumulative: false,
                name: "",
                code: "",
                role: "",
                discountType: "",
                discountValue: 0,
                minValue: 0,
                maxValue: 0,
                fromDate: null,
                toDate: null,
                limit: null,
                log: []
            },
            loading: true,
            search: this.$route.query.q ? this.$route.query.q : "",
            documents: [],
            items: [],

        }
    },
    mounted() {
        this.loadDocuments()
    },
    computed: {
        
        allCodes(){
            const result = []
            this.documents.forEach((doc) => {
                result.push(doc.code)
            })
            return result
        },
        headers() {
            return [{
                text: this.$t('marketing.promotions.form.name'),
                align: 'start',
                sortable: true,
                value: 'name',
            },
            {
                text: this.$t('marketing.promotions.form.code'),
                align: 'start',
                sortable: true,
                value: 'code',
            },
            {
                text: this.$t('marketing.promotions.form.value'),
                align: 'start',
                sortable: true,
                value: 'discountValue',
            },

            {
                text: this.$t('marketing.promotions.form.validDate'),
                align: 'start',
                sortable: true,
                value: 'from',
            },

            {
                text: this.$t('marketing.promotions.form.status'),
                align: 'start',
                sortable: true,
                value: 'status'
            },
            {
                text: this.$t('marketing.promotions.form.log'),
                align: 'start',
                sortable: true,
                value: 'log'
            },
            { text: '', align: 'end', value: 'id' },]
        },
        // { text: 'ID', value: 'uid' },



        formatedDueDate() {
            if(this.form.dueDate)
            return moment(this.form.dueDate).format('ll')
            return '-'
        },
        formatedFrom() {
            if(this.form.from)
            return moment(this.form.from).format('ll')
            return '-'
        }
    },
    watch: {
        '$route.params.tab'(value) {
            if (value != 1)
                this.search = this.$route.query.q ? this.$route.query.q : ''
        },
        'show'(value) {
            if (!value) {
                this.form = JSON.parse(JSON.stringify(this.model))
            }
        }
    },

    methods: {

        ...mapActions("snackbar", ["showSnack"]),
        checkValid(item) {
            if (moment().isBefore(moment(item.from))) {
                return 1
            }
            else {
                if (moment().isBefore(moment(item.dueDate, 'YYYY-MM-DD'))) {
                    return 2
                }
                else {
                    return 3
                }
            }
        },
        allowDates(date) {
            let from = moment(this.form.from, 'YYYY-MM-DD')
            return from.isBefore(moment(date, 'YYYY-MM-DD'))
            
    },
        openHistory(item) {
            this.historic.show = true
            this.historic.item = item
        },
        lastLog(item) {
            if (!item.hasOwnProperty('log')) return '-'
            if (!item.log.length) return '-'
            return item.log.length + (item.log.length > 1 ? ' vezes' : ' vez')
            const lengthLog = item.log.length
            const lastLog = item.log[item.log.length - 1]
            let result =  `<span style="font-size: 0;">${moment(lastLog.createdOn).format('X')}"></span>Ultima utilização:  ${moment(lastLog.createdOn).format('LLL')}`
            if(lengthLog > 1) 
                result += `(${lengthLog - 1} utilizações)`
            return result
        },
        addNew() {
            this.form = JSON.parse(JSON.stringify(this.model))
            this.show = true
        },
        edit(item) {
            this.form = JSON.parse(JSON.stringify(item))
            this.show = true
        },
        remove(item) {
            this.removeSnap = item
            this.toDelete = true
        },
        removeReserved() {
            const firebase = initializeApp(config)
            const db = getFirestore(firebase);
            deleteDoc(doc(db, "promotions", this.removeSnap.id)).then((res) => {

                this.loadDocuments()
            }).then(() => {
                this.toDelete = false
                this.removed = true
                this.showSnack({
                    text: this.$t('marketing.promotions.form.snackMessages.promotionRemoved'),
                    color: "success",
                    timeout: 2800,
                    icon: "mdi-check",
                });
            });;
        },
        objectId() {
            var timestamp = (new Date().getTime() / 1000 | 0).toString(16);
            return timestamp + 'xxxxxxxxxxxxxxxx'.replace(/[x]/g, () => {
                return (Math.random() * 16 | 0).toString(16);
            }).toLowerCase();
        },
         
    

        submit() {
            this.processing = true
            const firebase = initializeApp(config)
            const db = getFirestore(firebase);
            const Form = JSON.parse(JSON.stringify(this.form))
            Form.createdOn = moment().format()
            if(Form.role != 'Cupom de desconto')
            Form.code = null
            const id = this.form.id ? this.form.id : this.objectId()
            setDoc(doc(db, "promotions", id), Form).then(() => {
                this.processing = false
                // this.form = JSON.parse(JSON.stringify(this.snap))
                this.loadDocuments()

            }).then(() => {
                this.show = false
                this.showSnack({
                    text: this.$t('marketing.promotions.form.snackMessages.promotionAdded'),
                    color: "success",
                    timeout: 2800,
                    icon: "mdi-check",
                });
            });
        },
        loadDocuments() {
            this.loading = true
            const firebase = initializeApp(config)
            const db = getFirestore(firebase);
            const q = query(collection(db, "promotions"));
            const querySnapshot = getDocs(q);
            const documents = []
            querySnapshot.then((docs) => {
                docs.forEach((doc) => {
                    documents.push({ ...doc.data(), id: doc.id })
                })
                this.documents = documents
                this.loading = false
            })
        }
    },
}
</script>

<style lang="scss" scoped>
.hide-text {
    font-size: 0;
    text-indent: -999em;
}

fieldset {
    border: 1px solid #00000033;
    border-radius: 4px;
}

fieldset legend {
    //margin-left: 10px;
}
</style>
